import { z } from 'zod';
import { BaseResponseSchema, dateSchema, } from './primitives.js';
export const FileMetadataSchema = z.object({
    objectKey: z.string().min(1).max(250).trim(),
    originalName: z.string().min(1).max(250).trim(),
    mimeType: z.string().min(1).max(100).trim(),
    size: z.number().int(),
    uploadedAt: dateSchema.optional(),
    /** S3 key for a JPEG thumbnail when generated at upload time. */
    thumbnailObjectKey: z.string().min(1).max(250).trim().optional(),
});
/** Batch-resolve short-lived S3 GET URLs for object keys (browser loads S3 directly). */
export const PresignedObjectUrlRequestSchema = z.object({
    objectKeys: z.array(z.string().min(1)),
    expirySeconds: z.number().int().min(1).max(604800).optional(),
});
export const PresignedObjectUrlResponseSchema = BaseResponseSchema.extend({
    data: z.record(z.object({
        url: z.string().url(),
        expiresAt: dateSchema,
    })),
});
export const FileMetadataEntrySchema = z.object({
    originalName: z.string(),
    size: z.number().int(),
});
export const FileMetadataBatchRequestSchema = z.object({
    objectKeys: z.array(z.string().min(1)),
});
export const FileMetadataBatchResponseSchema = BaseResponseSchema.extend({
    data: z.record(FileMetadataEntrySchema),
});
//# sourceMappingURL=files.schemas.js.map